import React from 'react'
import { connect } from 'react-redux'
import { Button, Row, Col } from 'react-bootstrap'

import ChartCard from './ChartCard'

import { setChartToForm } from '../reducers/chartFormReducer'

import '../style.css'


const ChartsList  = (props) => {

  const {
    title,
    charts,
    chartViewButtonText,
    setChartToForm,
    routerProps,
  } = props


  const handleClick = (chart) => {
    setChartToForm(chart)
    routerProps.history.push(`${routerProps.location.pathname}/${chart.id}`)
  }

  const chartStringForSorting = (chart) => {
    let chartString = ''
    if (chart.site && typeof chart.site === 'object' && Object.keys(chart.site)) {
      chartString = `${chart.site.country} ${chart.site.number}`
    }
    return `${chartString} ${chart.patient_identifier}`
  }

  const sortedCharts = Array.isArray(charts) && charts.sort((a, b) => {
    const siteAString = chartStringForSorting(a)
    const siteBString = chartStringForSorting(b)
    return siteAString.localeCompare(siteBString)
  })


  return (
    <div className='ChartsContainer'>
      <Row>
        {title ?
          <Col sm={12} md={10}>
            <h4>
              {title}
            </h4>
          </Col>
          :
          null
        }

        <Col sm={12} md={2}>
          <Button
            onClick={() => routerProps.history.push('/charts')}
            className="chart-phase-button"
            style={{ marginLeft: "0px" }}
          >
            Back
          </Button>
        </Col>
          
        <br/>
        <br/>
        <br/>
      </Row>

      {Array.isArray(sortedCharts) && sortedCharts.length > 0 ?
        <Row>
          {sortedCharts.map(chart => {
            return (
              <Col key={chart.id} sm={12} md={6} lg={4}>
                <ChartCard
                  chartViewButtonText={chartViewButtonText}
                  chart={chart}
                  onClick={() => handleClick(chart)}
                />
              </Col>
            )
          })}
        </Row>
        :
        <center>
          <h5>
            There are no charts to display
        </h5>
        </center>
      }


    </div>
  )
}



const mapDispatchToProps = (dispatch) => {
  return {
    setChartToForm: (chart) => dispatch(setChartToForm(chart)),
  }
}

export default connect(null, mapDispatchToProps)(ChartsList)
